import { FunctionComponent, ReactNode } from 'react';
import Style from "./PrivateApp.style";
import { Footer, Content, Sidebar, Header } from "View/Application";
import { Layout } from 'antd';


type TProps = {
  children?: ReactNode;
};

export const PrivateApp: FunctionComponent<TProps> = ({ children, ...props }) => {
  return (
    <Style { ...props }>
      <Sidebar />
      <Layout className="layoutWrapper">
        <Header />
        <Content>
          { children }
        </Content>
        <Footer />
      </Layout>
    </Style>
  );
}
